import React from 'react';
import { ReactComponent as AppStoreBadge } from '../../../assets/svg/badges/AppStoreBadge.svg';
import { ReactComponent as PlayStoreBadge } from '../../../assets/svg/badges/PlayStoreBadge.svg';
import { Space } from 'antd';

const MobileAppBadges: React.FC<{}> = () => {
  return (
    <Space>
      <a href="https://apps.apple.com/us/app/forest-happier-communities/id1592053993">
        <AppStoreBadge style={{ width: 120, height: 40 }} />
      </a>
      <a href="http://play.google.com/store/apps/details?id=io.quickpower.forest.app">
        <PlayStoreBadge style={{ width: 133, height: 40 }} />
      </a>
    </Space>
  );
};

export default MobileAppBadges;
